import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Product from "./Product";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import {Swiper as SwiperInstance} from 'swiper';
import {useRef} from "react";
import {sortProductsByStock} from "../../utils/productSort";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ProductSlider({products, header}: {
    products: ProductInterface[],
    header: string
}) {

    const sortedProducts = sortProductsByStock(products);
    const prevRef = useRef<HTMLButtonElement>(null);
    const nextRef = useRef<HTMLButtonElement>(null);
    const paginationRef = useRef<HTMLDivElement>(null);

    return (<div className="prod-cat">
        <div className="container">
            <div className="d-flex flex-column prod-cat__row">
                <div>
                    <div className="prod-cat__title t-two">{header}</div>
                    {/* стрелки и точки — вне ленты, чтобы не налезали на карточки */}
                    <div className="prod-cat__slider">
                        <button ref={prevRef} type="button" className="swiper-button-prev prod-cat__nav prod-cat__nav--prev" aria-label="Назад"/>
                        <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={3}
                            slidesPerView={2}
                            slidesPerGroup={2}
                            navigation={{prevEl: prevRef.current, nextEl: nextRef.current}}
                            pagination={{el: paginationRef.current, clickable: true}}
                            onBeforeInit={(swiper: SwiperInstance) => {
                                // при первом рендере ref'ы ещё пустые — кнопки и точки подставляем перед инициализацией
                                const navigation = swiper.params.navigation as Exclude<typeof swiper.params.navigation, boolean | undefined>;
                                navigation.prevEl = prevRef.current;
                                navigation.nextEl = nextRef.current;
                                (swiper.params.pagination as Exclude<typeof swiper.params.pagination, boolean | undefined>).el = paginationRef.current;
                            }}
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            breakpoints={{
                                768: {
                                    slidesPerView: 3,
                                    slidesPerGroup: 3,
                                    spaceBetween: 3,
                                },
                                992: {
                                    slidesPerView: 4,
                                    slidesPerGroup: 4,
                                    spaceBetween: 3,
                                },
                                1400: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                    spaceBetween: 3,
                                },
                            }}
                        >
                            {sortedProducts.map((product, index) => (
                                <SwiperSlide key={`${product.id}-${product.link_type_id ?? 0}-${index}`}>
                                    <div className="prod-card"><Product product={product} /></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <button ref={nextRef} type="button" className="swiper-button-next prod-cat__nav prod-cat__nav--next" aria-label="Вперёд"/>
                    </div>
                    <div ref={paginationRef} className="prod-cat__pagination"/>
                </div>
            </div>
        </div>
    </div>)
}
